import { normalizeApiError } from '../api/apiError';
import { createReadAsyncThunk } from "../store/createReadAsyncThunk";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { VolunteeringInterest } from "../models/volunteering/common/volunteeringInterest";
import { VolunteeringInterests } from '../api/endpoints/volunteeringInterestsApi';
import { VolunteeringInterestDto } from "../models/volunteering/common/volunteeringInterestDto";
import { ApiRequestStatus } from "../enums/apiRequestStatus";

interface volunteeringInterestsSliceState {
    volunteeringInterests: VolunteeringInterest[] | null;
    volunteeringInterestsStatus: ApiRequestStatus;
    updateVolunteeringInterestsStatus: ApiRequestStatus;
}

const initialState: volunteeringInterestsSliceState = {
    volunteeringInterests: null,
    volunteeringInterestsStatus: ApiRequestStatus.Idle,
    updateVolunteeringInterestsStatus: ApiRequestStatus.Idle
}

export const getVolunteeringInterestsAsync = createReadAsyncThunk<VolunteeringInterest[]>(
    'volunteeringInterests/getVolunteeringInterestsAsync',
    async (_, thunkAPI) => {
        try {
            return await VolunteeringInterests.getVolunteeringInterestsAsync();
        } catch (error: unknown) {
            return thunkAPI.rejectWithValue(normalizeApiError(error));
        }
    }
)

export const updateVolunteeringInterestsAsync = createAsyncThunk<boolean, VolunteeringInterestDto[]>(
    'volunteeringInterests/updateVolunteeringInterestsAsync',
    async (volunteeringInterestDto, thunkAPI) => {
        try {
            return await VolunteeringInterests.updateVolunteeringInterestsAsync(volunteeringInterestDto);
        } catch (error: unknown) {
            return thunkAPI.rejectWithValue(normalizeApiError(error));
        }
    }
)

export const volunteeringSlice = createSlice({
    name: 'volunteeringSlice',
    initialState,
    reducers: {
        
    },
    extraReducers: (builder => {
        builder.addCase(getVolunteeringInterestsAsync.pending, (state) => {
            state.volunteeringInterestsStatus = ApiRequestStatus.Pending;
        });
        builder.addCase(getVolunteeringInterestsAsync.fulfilled, (state, action) => {
            state.volunteeringInterestsStatus = ApiRequestStatus.Fulfilled;
            state.volunteeringInterests = action.payload;
        });
        builder.addCase(getVolunteeringInterestsAsync.rejected, (state) => {
            state.volunteeringInterestsStatus = ApiRequestStatus.Rejected;
        });

        
        builder.addCase(updateVolunteeringInterestsAsync.pending, (state) => {
            state.updateVolunteeringInterestsStatus = ApiRequestStatus.Pending;
        });
        builder.addCase(updateVolunteeringInterestsAsync.fulfilled, (state, action) => {
            state.updateVolunteeringInterestsStatus = ApiRequestStatus.Fulfilled;
        });
        builder.addCase(updateVolunteeringInterestsAsync.rejected, (state) => {
            state.updateVolunteeringInterestsStatus = ApiRequestStatus.Rejected;
        });
    })
})
